import React from 'react'
import injectStyles from 'react-jss'
import StatsPage, { GridItem } from 'Components/Page/StatsPageWrapper'
import {
  ResultsTable,
  ResultsTableFilter,
  copyDataToClipboard,
} from './../../Components/Stats/ResultsTable'
import GScatterChart from './../../Components/Stats/GScatterChart'
import styles from './styles'
import { formatData } from './util'
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator'

const StatsCityPlan = ({ campaignResults, locationData, ...otherProps }) => {
  const currencySign = campaignResults.country.currencySign
  const {
    brandAmbassadorData,
    dayOfWeekData,
    timeOfDayData,
    locationDataProcessed,
    locationScatterChartAxisKeys,
  } = formatData(campaignResults, { ...otherProps, locationData, currencySign })
  return (
    <StatsPage>
      <StatsSection
        title="Brand Ambassadors"
        data={brandAmbassadorData}
        showFilterOptions
        currencySign={currencySign}
      />
      {locationDataProcessed ? (
        <StatsSection
          title={locationDataProcessed.title}
          data={locationDataProcessed.data}
          showFilterOptions
          currencySign={currencySign}
        />
      ) : (
        <LoadingIndicator label={'Loading locations data...'} />
      )}
      {locationDataProcessed && locationScatterChartAxisKeys ? (
        <GScatterChart
          title="CVR vs Flyers Distributed"
          titleKey="location"
          axisKeys={locationScatterChartAxisKeys}
          data={locationDataProcessed.data}
        />
      ) : null}
      <StatsSection
        title="Day of the Week"
        data={dayOfWeekData}
        showFilterOptions
        currencySign={currencySign}
      />
      <StatsSection
        title="Time of Day"
        data={timeOfDayData}
        showFilterOptions
        currencySign={currencySign}
      />
    </StatsPage>
  )
}

const StatsSection = injectStyles(styles)(
  ({ title, data, showFilterOptions, classes, currencySign }) => {
    // This seems quite akward, it's come about because the data sorting
    // was originally handled by the ResultsTable component, except we now
    // need to sort the data externally to that component so we can use it
    // in the 'Copy' button. So the ResultsTable component was refactored into
    // the basic component and the sorting component, ResultsTable and
    // ResultsTableFilter respectively.
    var Content = props => (
      <div className={classes.section}>
        <h1>
          {title}
          <button
            className={classes.copyButton}
            onClick={() => {
              copyDataToClipboard(props.legend, props.data, props.totals)
            }}
          >
            Copy
          </button>
        </h1>
        <GridItem>
          <div className={classes.tableContainer}>
            <ResultsTable
              {...props}
              className={classes.table}
              currencySign={currencySign}
            />
          </div>
        </GridItem>
      </div>
    )
    return (
      <ResultsTableFilter {...data}>
        <Content />
      </ResultsTableFilter>
    )
  },
)

export default StatsCityPlan
